import { render, staticRenderFns } from "./remoteConfig.vue?vue&type=template&id=27af8d70&scoped=true&"
import script from "./remoteConfig.vue?vue&type=script&lang=js&"
export * from "./remoteConfig.vue?vue&type=script&lang=js&"
import style0 from "./remoteConfig.vue?vue&type=style&index=0&id=27af8d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27af8d70",
  null
  
)

export default component.exports